<template>
  <div class="container resources">
    <div class="row mb-45">
      <div class="col-12">
        <h1>Additional Resources</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <crisis-side-bar />
      </div>

      <!-- start blogPosts  -->
      <div class="col-12 col-md-6 col-lg-8">
        <div class="row">
          <div class="col-12">
            <div class="dashboard-card">
              <label>External Tools</label>
              <h4 class="main mt-2" style="margin-bottom: 15px">
                Wellbeing Video Resources
              </h4>
              <p>
                Learn more about how to protect and support your mental health
                and wellbeing by watching this collection of educational video
                resources.
              </p>
              <a
                href="https://psychhub.com/mental-health-content"
                target="_blank"
                tag="button"
                class="btn btn-primary mt-2 btn-wide"
              >
                View Videos
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="dashboard-card blog-card">
              <label>BLOG POSTS</label>
              <h4 class="main mt-2">Recent Articles and Resources</h4>

              <div v-if="!blogPosts" class="row eq-height text-center">
                <Loader style="width: 100%" />
              </div>

              <div class="row eq-height" v-else-if="blogPosts.length === 0">
                <p>There are no posts yet! Check back later.</p>
              </div>

              <div class="row eq-height" v-else>
                <div
                  class="col-md-12 col-lg-6 blog-post"
                  v-for="post in blogPosts"
                >
                  <a :href="post.link">
                    <div
                      v-if="post.image"
                      class="upper"
                      :style="{ backgroundImage: `url(${post.image})` }"
                    />
                    <div v-else class="upper" />

                    <h4>{{ post.title }}</h4>
                    <div class="description" v-html="post.excerptHtml"></div>
                    <span class="date">
                      <font-awesome-icon
                        :icon="['fas', 'calendar']"
                        class="icon alt"
                      />
                      {{ post.date | dateOnly }}
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end blogPosts -->
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import Loader from '@/components/Loader';
import UserClient from '@/api/UserClient';
import CrisisSideBar from '@/crisis/CrisisSideBar.vue';
import moment from 'moment';

export default {
  name: 'Resources',
  components: {
    Card,
    CrisisSideBar,
    // VClamp,
    Loader
  },
  data() {
    return {
      userClient: new UserClient(this.$http),

      blogPosts: null,
      college: null
    };
  },
  mounted() {
    this.college = this.$store.getters.currentUser.school || null;

    this.blogPosts = null;

    try {
      fetch('https://www.bettermynd.com/wp-json/wp/v2/posts?per_page=4')
        .then((r) => r.json())
        .then(async (json) => {
          for (let i = 0; i < json.length; i++) {
            const post = json[i];
            if (
              post._links &&
              post._links['wp:attachment'] &&
              post._links['wp:attachment'].length
            ) {
              await fetch(post._links['wp:attachment'][0].href)
                .then((r) => r.json())
                .then((attachmentJson) => {
                  if (attachmentJson && attachmentJson.length) {
                    json[i].image = attachmentJson[0].guid.rendered || '';
                  }
                });
            }
          }

          this.blogPosts = json.map((row) => {
            let imageUrl = null
            if(row.image) {
              const originalImageUrl = new URL(row.image);
              imageUrl = new URL(
                originalImageUrl.pathname, 
                "https://www.bettermynd.com/");
            }
            return {
              title: (row.title && row.title.rendered) || '',
              contentHtml: (row.content && row.content.rendered) || '',
              excerptHtml: (row.excerpt && row.excerpt.rendered) || '',
              link: row.link,
              image: (imageUrl || '').toString(),
              date: moment(row.date).toDate(),
            };
          });
        });
    } catch (ex) {
      console.log(ex);
      this.blogPosts = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.resources {
  h4.main {
    font-size: 28px;
    margin-bottom: 30px;
  }

  .gradient {
    @include blue-gradient;

    p {
      color: rgba(white, 0.87);
    }

    b {
      margin-bottom: 3px;
      display: block;
    }

    a {
      display: block;
      margin-bottom: 5px;

      &:hover {
        color: $green;
        text-decoration: underline;
      }
    }
  }

  .dashboard-card {
    label {
      @include label;

      display: block;
    }
  }

  .blog-post {
    margin-top: 10px;

    a {
      &:hover {
        text-decoration: none;
      }

      .upper {
        @include background-cover;
        @include border-radius(10px);

        height: 180px;
        width: 100%;
        display: inline-block;
        vertical-align: top;
        margin-bottom: 15px;
        overflow: hidden;
        background-image: url('~@/assets/img/default-banner.jpg');
      }

      .description {
        color: rgba(white, 0.87);
        margin-top: 10px;
        margin-bottom: 20px;
      }

      .date {
        color: $green;
        font-size: 14px;
        margin-bottom: 20px;
        display: block;

        i,
        svg {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
